import { render } from "./data-box.vue?vue&type=template&id=4cc653b2"
import script from "./data-box.vue?vue&type=script&lang=js"
export * from "./data-box.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__